import React from 'react'

export const DropCap = ({ children }: { children: any }) => {
  return (
    <span className="float-left / pt-1 pr-1 pl-0.5 / font-bold font-serif text-5.5xl text-primary leading-3">
      {children}
    </span>
  )
}
